var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _path17, _circle, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.424 213C92.5736 197.684 134.809 175.213 175.22 159.689C175.936 159.048 176.664 158.403 177.404 157.753C193.961 143.132 216.067 124.892 218.73 104.95C221.351 84.9637 204.532 63.2319 183.956 51.4945C163.379 39.7981 139.047 38.0498 114.669 38.001C90.2913 37.9523 65.8697 39.5748 53.718 52.7987C41.6228 65.984 41.7976 90.8067 39.9625 113.455C38.1274 136.103 34.2413 156.613 40.1373 175.813C44.9563 191.615 56.4321 206.587 70.424 213Z",
    fill: "#E7EEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.163 154C189.018 153.263 182 143.944 182 132.885C182 120.037 195.54 95.7174 196.827 87.054C197.647 81.5439 201.343 33 229.416 33C244.723 33 246 63.0411 246 76.4773C246 107.864 200.532 134.6 200.532 150.903C197.486 152.157 194.355 153.192 191.163 154Z",
    fill: "#FFCCF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.101167,
    d: "M195 153C195 127.589 214.153 81.2922 231 65",
    stroke: "#FF7EA2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3442 203C85.907 202.57 82 197.566 82 191.118C82 184.908 83.7359 175.852 83.7359 167.45C83.7359 162.777 82 161.121 82 155.561C82 146.699 90.3601 144 93.291 144C97.605 144 99.9127 147.708 99.9127 149.672C99.9127 152.412 99.14 154.492 99.14 157.525C99.14 163.453 101.2 164.195 100.984 169.303C100.34 184.236 94.1693 198.834 88.7453 202.146L87.3442 203Z",
    fill: "#FFCCF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7927 202.471C89.5634 200.943 79.6485 152.624 71.0487 144.073C61.6929 134.78 54.0017 129.86 51.4622 126.809C46.9578 121.4 44.0894 101 24.2622 101C19.0174 101 6.65866 105.337 4.43492 123.694C3.70748 129.72 2.38463 138.938 14.922 152.297C23.3665 161.298 33.9286 158.199 44.2525 167.951C51.6848 174.971 50.6441 185.559 57.5846 194.506C63.1375 201.652 77.5542 211.293 87.7927 202.471Z",
    fill: "#FFCCF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.101167,
    d: "M85 203C85 191.147 47.1462 137.651 32 130",
    stroke: "#FF7EA2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.5578 203C87.1952 200.141 85.6657 175.851 90 167",
    stroke: "#FF7EA2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58 225C69.3076 208.737 170.319 153.251 231 143",
    stroke: "#145E7F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119 205.473V213H102V209.816L112.532 204L119 205.473Z",
    fill: "#3A4944"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.122 200C158.978 202.044 161 207.341 161 207.341L152.552 213H144.897L144 209.873L153.616 202.031L158.122 200Z",
    fill: "#3A4944"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.65 25.8292C120.66 24.4972 117.867 24.7979 115.41 26.53C114.48 27.1723 113.69 27.9891 113.086 28.933C113.006 28.8981 112.92 28.8787 112.832 28.8758C111.639 28.8758 91.8135 39.2606 92.0013 44.0517C92.1891 48.8428 98.84 56.5264 101.162 58C101.162 58 111.639 53.2089 111.076 51.6707C110.513 50.1325 104.478 45.2097 103.42 44.2356C104.664 43.5994 114.616 33.9427 115.74 32.8493C116.92 32.6021 118.032 32.1098 119.001 31.4055C121.452 29.671 122.642 27.1761 121.65 25.8292Z",
    fill: "#E9A174"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.313 67.8374C117.586 65.9791 113.823 50.3962 109.791 50.0137C105.758 49.6313 98.7255 57.3547 99.0083 59.5467C99.2911 61.7388 109.571 72.509 115.313 67.8374Z",
    fill: "#FDD484"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107 105.263C107 107.848 108.279 197.278 110.58 205.032C112.626 206.066 117.996 206.325 119.786 205.549C121.577 204.774 133 106.679 133 102.373C133 98.0673 107 105.263 107 105.263Z",
    fill: "#B99A78"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.362 202.945C150.945 199.071 119.468 123.833 117 105.281C119.584 103.238 138.817 99.981 140.374 103.69C141.931 107.399 160.624 199.104 159.984 200.295C159.344 201.486 155.18 203.343 153.362 202.945Z",
    fill: "#C9AA89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.893 57C143.431 57 142.406 101.973 138.816 104.744C135.226 107.515 107.149 107.641 105.354 105.626C103.559 103.61 99.3178 57 126.893 57Z",
    fill: "#FFD98F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.475 58.5895C130.129 59.6947 122.862 58.3532 123.002 57.1032L124.244 46L133 47.743C133 47.743 130.827 57.4893 130.475 58.5895Z",
    fill: "#E19566"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 44,
    rx: 7,
    ry: 10,
    fill: "#E9A174"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140 40.4818C140 38.5389 138.23 37.1373 138.23 36.0599C138.23 34.9825 138.836 33.0525 137.481 31.6713C135.833 29.9939 133.206 30.6935 130.855 30.6935C128.645 30.6935 127.425 28 124.409 28C122.399 28 122.654 30.7369 121.902 31.416C121.345 31.9266 117 32.9069 117 34.9902C117 37.3186 117.058 40.4435 121.669 40.4435C121.975 39.3253 123.129 36.8692 124.444 35.7765C125.12 36.0829 128.825 37.6862 129.743 37.9696C130.66 38.253 132.001 42.3736 133.423 42.8714C134.845 43.3693 134.935 46.1138 135.974 45.9963C137.013 45.8789 140 45.4194 140 40.4818Z",
    fill: "#7E5933"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 44.5,
    r: 2.5,
    fill: "#E9A174"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178 66L149 209",
    stroke: "#145E7F",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.494 105.285C170.747 104.51 169.783 103.993 168.736 103.806C165.393 98.2688 154.031 81.2011 149.021 75C145.409 77.662 141 82.3173 141 82.3173C142.842 84.4366 156.64 101.188 163.982 107.757C163.973 109.147 164.516 110.481 165.486 111.453C167.343 113.361 170.195 113.526 171.854 111.826C173.514 110.126 173.351 107.194 171.494 105.285Z",
    fill: "#E9A174"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.016 64.1573C140.875 59.3199 152.183 71.0172 151.998 74.0937C151.812 77.1703 143.121 83.9925 140.148 84C136.519 84.005 128.177 68.2753 134.016 64.1573Z",
    fill: "#FFDE9C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAbout);
export default __webpack_public_path__ + "static/media/IllustrationAbout.ffae766d9da9173a7777628b979cc2b4.svg";
export { ForwardRef as ReactComponent };